function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import Table from '../../common/table/Table.react';
import ConstantsTemplateEdit from './ConstantsTemplateEdit.react';
var ConstantsTemplate = function ConstantsTemplate(_ref) {
  var title = _ref.title,
    slug = _ref.slug,
    constants = _ref.constants,
    disableSelectApp = _ref.disableSelectApp,
    _ref$disableAdd = _ref.disableAdd,
    disableAdd = _ref$disableAdd === void 0 ? false : _ref$disableAdd,
    _ref$hideApp = _ref.hideApp,
    hideApp = _ref$hideApp === void 0 ? false : _ref$hideApp,
    addModalAction = _ref.addModalAction;
  var tableData = {
    columns: {
      name: 'Constant Name',
      key: 'Key',
      value: 'Value',
      description: 'Description'
    },
    data: constants
  };
  if (!hideApp) tableData.columns.clientApp = 'Application';
  var addModal = function addModal(_ref2) {
    var _ref2$constant = _ref2.constant,
      constant = _ref2$constant === void 0 ? null : _ref2$constant;
    addModalAction({
      component: /*#__PURE__*/React.createElement(ConstantsTemplateEdit, {
        slug: slug,
        title: title,
        constant: constant,
        constants: constants,
        disableSelectApp: disableSelectApp
      })
    });
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: title,
    button: {
      label: 'Add',
      type: 'add',
      disabled: disableAdd,
      onClick: function onClick() {
        return addModal({
          slug: slug,
          title: title,
          constants: constants,
          disableSelectApp: disableSelectApp
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    actions: {
      edit: {
        onEdit: function onEdit(constant) {
          return addModal({
            constant: constant
          });
        }
      }
    }
  })));
};
var mdtp = {
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(ConstantsTemplate);